import React from 'react';

const backButton = props => (
  <button
    className="back header-btn"
    aria-label="Back"
    onClick={props.onBackClick}
  >
    <i className="skinny-icon arrow-left" />
  </button>
);

export default backButton;
